import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { constant } from 'app/app.constants';
import { SsnService } from '../ssn.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-ssn',
  templateUrl: './ssn.component.html',
  styleUrls: ['./ssn.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SsnComponent),
      multi: true
    }
  ]
})
export class SsnComponent implements OnInit, ControlValueAccessor {

  @Input() actions: any;
  @Input() type = 0;
  @Input() id: number;
  @Output() reload = new EventEmitter<any>();
  @Output() isEdit = new EventEmitter<boolean>();

  MASK_SSN = constant.MASK_SSN_DRIVER;
  editing = false;
  action: any;
  ssn: string;
  isDisabled = true;

  onChange = (_: any) => { };
  onTouched = () => { };

  constructor(
    private ssnService: SsnService,
    private sweetAlertHelper: SweetAlertHelper,
  ) { }

  ngOnInit() {
    this.ssnService.disabledInput.subscribe((event: boolean) => {
      if (event) {
        this.restarField();
      }
    });
  }

  restarField() {
    this.editing = false;
    this.isDisabled = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['actions'] && this.actions) {
      this.restarField();
      this.action = this.actions;
    }

    if (this.type && this.type === ActionType.rider && this.ssn === null) {
      this.resetSatusInput();
    }

    if (this.type && this.type === ActionType.drivers && !this.ssn ) {
      this.editing = true;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}

  writeValue(obj: any): void {
    this.ssn = null;
    if (obj !== undefined && obj !== null) {
      if (this.id) {
        this.restarField();
      } else {
        this.resetSatusInput();
      }
      this.ssn = obj;
      this.onChange(obj);
    }

    if (!this.ssn) {
      this.resetSatusInput();
    }
  }

  resetSatusInput() {
    this.isDisabled = !this.actions.updateSsn;
    this.editing = true;
  }

  onShow() {
    this.editing = !this.editing;
    this.isDisabled = !this.action.updateSsn;
    this.isEdit.emit(this.editing);
    const typeAction = {
      'ondemand': () => this.getOndemand(),
      'drivers': () => this.getMctDrivers(),
      'rider': () => this.getRider(),
    };
    return  typeAction[ActionType[this.type]]();
  }

  getMctDrivers(): void {
    this.ssnService.getSsnMctDriver(this.id).subscribe(res => {
      this.onSetDataNew(res);
    }, (error) => {
      this.errorMessage(error);
    });
  }

  getOndemand(): void {
    this.ssnService.getSsnOndemand(this.id).subscribe(res => {
      this.onSetDataNew(res);
    }, (error: any) => {
      this.errorMessage(error);
    });
  }

  getRider(): void {
    this.ssnService.getSsnRider(this.id).subscribe(res => {
      this.onSetDataNew(res);
    }, (error: any) => {
      this.errorMessage(error);
    });
  }

  onSetDataNew(res: string) {
    this.ssn = res;
    this.onTouched();
    this.onChange(res);
  }


  errorMessage(error) {
    this.sweetAlertHelper.captureException(error);
    this.editing = false;
  }

  onEmitText(event: string) {
    this.editing = true;
    this.isEdit.emit(this.editing);
    this.onChange(event);
  }

  onKeyup(val) {
    if (val) {
      val = val.replace(/[^0-9\.]/g, '');
      if (val.split('.').length > 2) {
        val = val.replace(/\.+$/, '');
      }
    }
    this.ssn = val;
  }

  get showPencil(): boolean {
    return this.actions.showSsn && !this.editing && !!this.id;
  }

  get disbaledInput(): boolean {
    return this.action.updateSsn;
  }
}

enum ActionType {
  ondemand = 1,
  drivers = 2,
  rider = 3,
}




// WEBPACK FOOTER //
// ./src/app/utils/ssn-module/ssn/ssn.component.ts